<kendo-dropdownlist
  #dropdownList
  (open)="onDropdownOpen($event)"
  (opened)="onDropdownOpened($event)"
  (valueChange)="onDropdownChange($event)"
  (selectionChange)="onSelectionChange($event)"
  (filterChange)="onDropdownFilterChange($event)"
  [filterable]="filterable()"
  [valuePrimitive]="valuePrimitive()"
  [textField]="textField()"
  [valueField]="valueField()"
  [virtual]="virtual()"
  [data]="data()"
  [ngStyle]="styles()"
  [value]="value()"
>
  <ng-template
    kendoDropDownListItemTemplate
    let-dataItem
  >
    <div (click)="onItemClick(dataItem)">
      {{ dataItem[textField()] }}
    </div>
  </ng-template>
  <kendo-svg-icon
    [icon]="chevronDownIcon"
    themeColor="inherit"
  ></kendo-svg-icon>
</kendo-dropdownlist>
